import React, { useMemo, useState } from "react";
import { DashboardService } from "api/axios";
import { BarChart } from "components";
import {
	WeekNumberToDateRange,
	MonthStartEnd
} from "helper/WeekNumberToDateRange";
import moment from "moment";
import { useQuery } from "react-query";

// type VisitStatus = "VISIT" | "SPH" | "PO" | "SCHEDULING" | "DO" | "REJECTED";
const buttons = [
	{
		value: "VISIT",
		title: "VISIT"
	},
	{
		value: "SPH",
		title: "SPH"
	},
	{
		value: "PO",
		title: "PO"
	},
	{
		value: "SCHEDULING",
		title: "SCHEDULING"
	},
	{
		value: "DO",
		title: "DO"
	},
	{
		value: "REJECTED",
		title: "REJECTED"
	}
];

const thisMonth = moment().endOf("month").format("YYYY-MM-DD");

const { startDate: initialMonthStartDate, endDate: initialMonthEndDate } =
	MonthStartEnd(thisMonth, 3);
export default function VisitaionStatusChart() {
	const [visitationStatus, setVisitationStatus] = useState(
		{} as VisitationStatusResponse
	);
	const [dateRange, setDateRange] = useState({
		startDate: initialMonthStartDate,
		endDate: initialMonthEndDate
	});
	const [filterType, setFilterType] = useState("monthly");
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [status, setStatus] = useState("VISIT");

	useQuery(
		["visitation-status", dateRange, page, status],
		async () => {
			const { startDate, endDate } = dateRange;
			return await DashboardService.visitationStatusCount({
				startDate,
				endDate,
				type: filterType,
				page,
				size: 10,
				status
			});
		},
		{
			enabled: true,
			onSuccess: (res) => {
				setVisitationStatus(res.data.data as VisitationStatusResponse);
				setTotalPages(res.data.data.totalPages);
			}
		}
	);

	const dataChart = useMemo(() => {
		const chart: { label: string; [key: string]: number | string }[] = [];
		if (visitationStatus.visitation) {
			visitationStatus.visitation.reverse().forEach((visit) => {
				chart.push({
					label: visit.fullName,
					"Jumlah Kunjungan": +visit.visitationCount
				});
			});
		}
		return chart;
	}, [visitationStatus]);

	const labels = ["Jumlah Kunjungan"];
	return (
		<>
			<BarChart
				data={dataChart}
				labels={labels}
				title="Sales Visitation By Status"
				indexBy="label"
				filterOnChange={({ type, dateRange }) => {
					setDateRange(dateRange);
					setFilterType(type);
				}}
				layout="horizontal"
				leftLegend=""
				bottomLegend="Jumlah Kunjungan"
				setPage={(page) => {
					setPage((curr) => {
						if (curr !== page) {
							return page;
						}
						return curr;
					});
				}}
				totalPage={totalPages}
				initialDate={{
					startDate: initialMonthStartDate,
					endDate: initialMonthEndDate
				}}
				togleButtons={buttons}
				buttonOnChange={(val) => {
					setStatus(val);
				}}
			/>
		</>
	);
}
